import posthog from 'posthog-js';
import TrackingAbstract from './_trackingAbstract';
import config from '../env.config';
const POSTHOG_INSTITUTION_GROUP_TYPE = 'clinic';
const CLINIC_PLAN_TYPE = 'clinic';
export default class PosthogTracking extends TrackingAbstract {
    initProvider(authenticated) {
        if (!authenticated) {
            return;
        }
        this.ensurePosthogStarted();
    }
    identifyUser(user, institution, _meta) {
        if (!this.ensurePosthogStarted()) {
            return;
        }
        const membership = user.institutionMember;
        const resolvedInstitution = membership?.institution ?? institution;
        posthog.identify(user.id.toString(), {
            email: user.email,
            plan_type: CLINIC_PLAN_TYPE,
        });
        const institutionName = resolvedInstitution.name;
        posthog.group(POSTHOG_INSTITUTION_GROUP_TYPE, String(resolvedInstitution.id), institutionName != null && institutionName !== ''
            ? { name: institutionName }
            : undefined);
    }
    unidentifyUser() {
        if (!posthog.__loaded) {
            return;
        }
        posthog.reset();
        posthog.opt_out_capturing();
    }
    ensurePosthogStarted() {
        const apiKey = config.posthogConfig?.apiKey;
        if (!apiKey) {
            this.$log.warn('PostHog apiKey not configured, skipping initialization');
            return false;
        }
        const apiHostRaw = config.posthogConfig?.apiHost;
        const apiHost = typeof apiHostRaw === 'string' && apiHostRaw.trim() !== ''
            ? apiHostRaw.trim()
            : null;
        if (!apiHost) {
            this.$log.warn('PostHog apiHost not configured, skipping initialization');
            return false;
        }
        if (!posthog.__loaded) {
            posthog.init(apiKey, {
                api_host: apiHost,
                autocapture: true,
                capture_pageview: true,
                capture_pageleave: true,
                capture_performance: true,
                person_profiles: 'identified_only',
            });
            posthog.register({ app_version: 'OG' });
        }
        else if (posthog.has_opted_out_capturing()) {
            posthog.opt_in_capturing({ captureEventName: false });
        }
        return posthog.__loaded;
    }
    track(_eventName, _properties, _context) {
        // No-op: PostHog autocapture handles event tracking.
    }
    trackWithoutParams(_eventName, _context) {
        // No-op: PostHog autocapture handles event tracking.
    }
    trackWithExplicitProperties(_eventName, _properties) {
        // No-op: PostHog autocapture handles event tracking.
    }
    trackPageView() {
        // No-op: PostHog auto-captures pageviews.
    }
    trackScreenshare(_phase, _data = {}) {
        // No-op: PostHog autocapture handles event tracking.
    }
}
